var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section-card',{attrs:{"container-class":"py-4 px-6"}},[_c('base-typography',{staticClass:"label-small",attrs:{"value":"案件名","single":""}}),_c('base-typography',{staticClass:"mt-2",attrs:{"value":_vm.offerName,"single":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }